import React from 'react';
import { BiMessageSquareDots } from 'react-icons/bi';
import StartConversationButton from './StartConversationButton';
import { START_CONVERSATION_LABEL } from './messagingLabels';

/**
 * Right panel when no conversation is selected (desktop) or browse prompt.
 */
export default function MessagingEmptyPanel({ onStartConversation }) {
  return (
    <div className="messaging-page__empty-panel">
      <div className="messaging-page__empty-panel-inner">
        <span className="messaging-page__empty-icon" aria-hidden>
          <BiMessageSquareDots />
        </span>
        <h2 className="messaging-page__empty-title">Your messages</h2>
        <p className="messaging-page__empty-copy">
          Pick someone from the list or start a new conversation. Messages feel private, direct, and
          in the moment.
        </p>
        <StartConversationButton onClick={onStartConversation} className="messaging-page__empty-cta" />
        <p className="messaging-page__empty-hint">
          Tip: use <strong>{START_CONVERSATION_LABEL}</strong> or browse Followers &amp; Following on
          the left.
        </p>
      </div>
    </div>
  );
}
